import React from 'react';
import './Footer.css';

const Footer: React.FC = () => (
  <footer className="footer">
    <div className="footer-images">
      <img src="/images/workshop_surface.jpg" alt="Luthier's workbench" />
      <img src="/images/workshop_sign.jpg" alt="Outdoor sign pointing towards workshop" />
      <img src="/images/violin_bridge.jpg" alt="Closeup of a violin bridge and f-hole" />
    </div>
  </footer>
);

export default Footer;